import { SVGProps } from 'react';

const ReactionIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
      <g clipPath="url(#clip0_7292_12192)">
        <path
          d="M10.7458 10.732C13.0131 8.46469 13.013 4.78871 10.7457 2.52147C8.47837 0.254239 4.80239 0.254304 2.53515 2.52162C0.267919 4.78893 0.267984 8.46491 2.5353 10.7321C4.80261 12.9994 8.47859 12.9993 10.7458 10.732Z"
          stroke="#14B8FA"
          strokeWidth="1.64147"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.50785 6.62695C8.50785 7.65818 7.6719 8.49413 6.64068 8.49413C5.60945 8.49413 4.77345 7.65818 4.77345 6.62695M4.45506 27.1798H11.3411C11.8831 27.1798 12.4139 27.0259 12.8719 26.7361C13.3298 26.4463 13.6961 26.0325 13.9282 25.5427L15.3435 22.5551C15.9928 21.1845 14.9955 19.6041 13.4788 19.6004L10.797 19.5922L11.2953 17.4449C11.539 16.3946 10.8711 15.3493 9.81566 15.1293H9.2185L8.08528 17.5216C7.7445 18.2409 7.218 18.8563 6.56008 19.3044L4.45511 20.7376M20.5624 20.6945L15.1832 16.1159C14.4152 15.4686 13.9525 14.5238 13.9598 13.5259C13.9601 13.485 13.961 13.444 13.9627 13.4027C14.0401 11.4689 15.6435 9.90404 17.6 9.85097C18.7878 9.81874 19.8544 10.3341 20.5624 11.1597C21.2703 10.3343 22.3367 9.8189 23.5243 9.85097C25.4844 9.90388 27.0896 11.4743 27.1625 13.4118C27.1642 13.4546 27.165 13.4973 27.1651 13.5398C27.1687 14.5353 26.7068 15.477 25.9402 16.1223L20.5624 20.6945ZM0.847321 20.7357H4.45506V27.1761H0.847321V20.7357Z"
          stroke="#14B8FA"
          strokeWidth="1.64147"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7292_12192">
          <rect width="28" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ReactionIcon;
